import FileDownload from 'js-file-download';
import showToast from '../../toasts/operations/showToast.operation';
import jsToCsv from '../../utils/jsToCsv';
import fetchGroupWiseParticipantsPerSet from '../api/fetchGroupWiseParticipantsPerSet';
import refreshAccessToken from '../../actions/accessToken/refreshAccessToken.action';
import { currentClassRoomId as getCurrentClassRoomId } from '../../selectors/classroom';

const userFields = ['groupName', 'email', 'firstName', 'lastName', 'studentId'];
const userHeaders = {
  groupName: 'Group name',
  email: 'Email address',
  firstName: 'First name',
  lastName: 'Last name',
  studentId: 'Student ID',
};

const normalizeGroupSetExportData = (groupName, participants) =>
  participants.map((participant) => ({
    groupName,
    email: participant.email,
    firstName: participant.firstName,
    lastName: participant.lastName,
    studentId: participant.custom?.studentId ?? '',
  }));

const exportGroupSetToCSV = (groupSetId) => async (dispatch, getState) => {
  try {
    const state = getState();
    const dataGroups = state.data.groups;
    const set = dataGroups.sets[groupSetId];
    const participants = [];

    const spaceId = getCurrentClassRoomId(state);
    const accessToken = await refreshAccessToken(
      dispatch,
      getState
    )({ spaceId });

    const { groups } = await fetchGroupWiseParticipantsPerSet(
      accessToken,
      groupSetId,
      spaceId
    );

    groups.forEach((group) => {
      participants.push(
        normalizeGroupSetExportData(group.name, group.educators)
      );
      participants.push(
        normalizeGroupSetExportData(group.name, group.students)
      );
    });

    FileDownload(
      jsToCsv(userFields, participants.flat(), userHeaders),
      `${set.name}-participants.csv`,
      'text/csv;charset=utf-8;'
    );

    dispatch(
      showToast({
        emoji: '🙌',
        message: 'Success! The CSV was exported!',
      })
    );
  } catch (e) {
    dispatch(
      showToast({
        emoji: '🤔',
        message: 'Oops! We failed to download the list of participants',
      })
    );
  }
};

export default exportGroupSetToCSV;
